var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.9302 77.8604C60.4308 77.8604 77.8604 60.4308 77.8604 38.9302C77.8604 17.4296 60.4308 0 38.9302 0C17.4296 0 0 17.4296 0 38.9302C0 60.4308 17.4296 77.8604 38.9302 77.8604Z",
    fill: "#3C72D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.94 62.5172H33.2109V25.963C33.2109 20.1075 36.4558 15.3607 43.8132 15.3607C45.8808 15.3132 47.9487 15.4371 49.9959 15.7309V23.4954H45.6729C43.0698 23.4954 40.8624 25.4131 40.94 28.2283V62.5172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.1368 38.9387H27.8652V32.0664H49.9974L49.1368 38.9387Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.0e693300cbd80b2ae04572ec246baf51.svg";
export { ForwardRef as ReactComponent };